<template>
  <EdroneCard>
    <img
      alt="Edrone logo"
      class="center-block tw:mb-5"
      src="https://d3vhsxl1pwzf0p.cloudfront.net/images_2_6/v2/logo.svg"
      width="100"
    />
    <h4 class="bold text-center">
      {{ $_trans("This account has been suspended") }}
    </h4>
    <p class="text-center tw:mb-3">
      {{
        $_trans(
          "Hello! We need your attention! Our system has detected an issue with your account; it could be related to a payment overdue or to your monthly limit - if you have exceeded your subscription plan. To restore your access please contact us at payments@edrone.me."
        )
      }}
    </p>

    <SuspensionModalButtons @click="$router.push({ name: 'PageAccountBilling' })" />
  </EdroneCard>
</template>

<script lang="ts" setup>
import SuspensionModalButtons from "vue-app/components/Suspension/SuspensionModalButtons.vue";
import EdroneCard from "../../../assets/js/ui/EdroneCard.vue";
</script>
